// app/middleware/notFoundQueens.ts
import { useWebContext } from "~/composables/webContext";

export default defineNuxtRouteMiddleware(() => {
  const { isQueens } = useWebContext();

  if (isQueens) {
    throw createError({ statusCode: 404 });
  }
});
